namespace SolovisGateway.Admin.DataEnvironments {

    /**
     * AdminEnvironmentControl presents the user interface for administrating a single data environment.     
     */
    export class AdminEnvironmentControl extends Solovis.UI.BaseControl {

        private _dataEnvironmentId;
        private _initError;

        private _toolbarContainer;
        private _toolbar: Solovis.UI.Toolbar;

        private _tableDiv;
        private _dbStatusDiv;
        private _customDataDiv;

        private _updateDbStatusCount = 0;

        private _envInfo;


        constructor(options) {
            super(options);

            this._dataEnvironmentId = options.dataEnvironmentId;
        }

        public async doInitAsync(): Promise<void> {
            let self = this;

            let summaryResponse = await Solovis.Rpc.invokeAndWait(
                "~/Admin/DataEnvironmentAdmin/GetDataEnvironmentSummary",
                { dataEnvironmentId: this._dataEnvironmentId });
                
            this._envInfo = summaryResponse.result.dataEnvironment;
        }

        public doRender() {
            let self = this;

            // Set up the toolbar.
            let toolbarContainer = $("<div>").appendTo(this.container);

            var toolbar = new Solovis.UI.Toolbar({
                container: toolbarContainer
            });

            toolbar.addItem({
                name: "editDataEnvironmentButton",
                createToolbarItem: function () {
                    var editDataEnvironmentButton = new Solovis.UI.Buttons.Button({
                        element: $("<div>").text("Edit").prepend($("<span>").css("padding-right", "5px").addClass("fa fa-pencil")),
                        size: "small",
                        click: function () {
                            self._showEditEnvironment();
                        }
                    });

                    return editDataEnvironmentButton;
                }
            });

            toolbar.addItem({
                name: "reloadEnvironmentPoolDataButton",
                createToolbarItem: function () {
                    var reloadEnvironmentPoolDataButton = new Solovis.UI.Buttons.Button({
                        text: "Reload Environment Pool Data",
                        size: "small",
                        click: function () {
                            self._reloadEnvironmentPoolData();
                        }
                    });

                    return reloadEnvironmentPoolDataButton;
                }
            });

            toolbar.addItem({
                name: "showModules",
                createToolbarItem: function () {
                    var button = new Solovis.UI.Buttons.Button({
                        text: "Show Modules",
                        size: "small",
                        click: function () {
                            self._showModules();
                        }
                    });

                    return button;
                }
            });

            toolbar.addItem({
                name: "manageUsers",
                createToolbarItem: function () {
                    var button = new Solovis.UI.Buttons.Button({
                        text: "Manage Users",
                        size: "small",
                        click: function () {
                            window.location.href = Solovis.resolveUrl("~/DataEnvironment/ManageUsers?dataEnvironmentId=" + self._dataEnvironmentId);
                        }
                    });

                    return button;
                }
            });

            toolbar.addItem({
                name: "moreActionsDropdown",
                alignment: "right",
                createToolbarItem: function () {
                    var moreActionsDropDown = new Solovis.UI.Buttons.DropdownButton(
                        {
                            text: "More Actions",
                            size: "small",
                            links: [
                                {
                                    label: "Create Database For Data Environment",
                                    click: function () {
                                        self._showCreateDatabase();
                                    }
                                },
                                {
                                    label: "Erase Data Environment",
                                    click: function () {
                                        self._showEraseDataEnvironment();
                                    }
                                }
                            ],
                            offsetRight: true,
                            fromRightEdge: true
                        });

                    return moreActionsDropDown;
                }
            });


            this._tableDiv = $("<div>").appendTo(this.container);
            this._dbStatusDiv = $("<div>").css("display", "none").appendTo(this.container);

            this._customDataDiv = $("<div>").css("display", "none").appendTo(this.container);

            this._updateEnvironmentTable();            
        }        

        private _updateEnvironmentTable() {
            let self = this;

            let dataEnvironmentInfo = this._envInfo;

            this._tableDiv.html("");

            if (dataEnvironmentInfo.isTestEnvironment) {
                let testDiv = $("<div style='margin-top: 10px; font-weight: bold; padding: 7px; border: 1px solid #ea7272; background-color: #fec5c5'>")
                    .appendTo(this._tableDiv)
                    .text("TEST ENVIRONMENT");
            }

            let table = $("<table>").addClass("table table-striped").appendTo(this._tableDiv);
            let colgroup = $("<colgroup>").appendTo(table);
            let col = $("<col>").css("width", "150px").appendTo(colgroup);

            let tbody = $("<tbody>").appendTo(table);

            let addNameValueHtml = function (labelText, valueHtml) {
                let row = $("<tr>").appendTo(tbody);
                $("<td>").css("vertical-align", "middle")
                    .append($("<strong>").text(Solovis.isNotNull(labelText) ? labelText : ""))
                    .appendTo(row);
                $("<td>").css("vertical-align", "middle")
                    .html(Solovis.isNotNull(valueHtml) ? valueHtml : "")
                    .appendTo(row);
            };

            let addNameValueText = function (labelText, valueText) {
                addNameValueHtml(labelText, $("<span>").text(Solovis.isNotNull(valueText) ? valueText : ""));
            };
          
            addNameValueText("Subdomain", dataEnvironmentInfo.subdomain);
            addNameValueText("Site Virtual Path", dataEnvironmentInfo.siteVirtualPath);
            addNameValueText("Description", dataEnvironmentInfo.description);
            addNameValueText("Port", dataEnvironmentInfo.port);

            let envPoolDiv = $("<div>");
            if (Solovis.isNotNull(dataEnvironmentInfo.environmentPoolId)) {
                $("<a>").text(dataEnvironmentInfo.environmentPoolName)
                    .attr("href", Solovis.resolveUrl("~/Admin/EnvironmentPoolAdmin/Info/?poolId=" + dataEnvironmentInfo.environmentPoolId))
                    .appendTo(envPoolDiv);
            }
            addNameValueHtml("Environment Pool", envPoolDiv);

            let orgDiv = $("<div>");
            if (Solovis.isNotNull(dataEnvironmentInfo.organizationId)) {
                $("<a>").text(dataEnvironmentInfo.organizationName)
                    .attr("href", Solovis.resolveUrl("~/Admin/OrganizationAdmin/Info/?organizationId=" + dataEnvironmentInfo.organizationId))
                    .appendTo(orgDiv);
            }
            addNameValueHtml("Organization", orgDiv);            

            if (dataEnvironmentInfo.hasDatabase) {
                addNameValueText("Database Server", dataEnvironmentInfo.databaseServer);
                addNameValueText("Database Name", dataEnvironmentInfo.databaseName);
            }

            if (!dataEnvironmentInfo.hasDatabase) {
                let createDatabaseDiv = $("<div>").css("margin-top", "15px").appendTo(this._tableDiv);
                let createDatabaseButton = $("<button>").text("Create Database").appendTo(createDatabaseDiv)
                    .click(function () {
                        self._showCreateDatabase();
                    });
            }

            this._updateDbStatusDisplay();
            this._updateCustomDataDiv();
        }


        private _updateDbStatusDisplay() {
            let self = this;
            if (!this._envInfo || !this._envInfo.hasDatabase) {
                this._dbStatusDiv.toggle(false);
                return;
            }

            this._dbStatusDiv.html("");
            this._dbStatusDiv.toggle(true);
            $("<h3>").text("Database Status").appendTo(this._dbStatusDiv);

            let statusDiv = $("<div>").text("Checking status...").appendTo(this._dbStatusDiv);

            let operationInProgressDiv = $("<div>").appendTo(this._dbStatusDiv);

            let table = $("<table>").addClass("table table-striped").appendTo(this._dbStatusDiv);
            let colgroup = $("<colgroup>").appendTo(table);
            let col = $("<col>").css("width", "150px").appendTo(colgroup);

            let tbody = $("<tbody>").appendTo(table);

            let addNameValueHtml = function (labelText, valueHtml) {
                let row = $("<tr>").appendTo(tbody);
                $("<td>").css("vertical-align", "middle")
                    .append($("<strong>").text(labelText))
                    .appendTo(row);
                $("<td>").css("vertical-align", "middle")
                    .html(Solovis.isNotNull(valueHtml) ? valueHtml : "")
                    .appendTo(row);
            };

            let addNameValueText = function (labelText, valueText) {
                addNameValueHtml(labelText, $("<span>").text(Solovis.isNotNull(valueText) ? valueText : ""));
            };

            let extraActionsDiv = $("<div>").appendTo(this._dbStatusDiv);

            this._updateDbStatusCount++;
            let attemptCo = this._updateDbStatusCount;
            Solovis.Rpc.invoke(
                "~/Admin/DataEnvironmentAdmin/CheckDatabaseStatus",
                {
                    dataEnvironmentId: this._dataEnvironmentId
                },
                function (response, success) {
                    if (self._updateDbStatusCount === attemptCo) {
                        if (success) {
                            let status = response.result.status;
                            statusDiv.remove();
                            addNameValueText("Connection", status.connectSuccess ? "Succeeded" : "Failed");

                            if (status.azureOperationInProgress) {
                                $("<div style='font-weight: bold; padding: 7px; border: 1px solid #ea7272; background-color: #fec5c5'>")
                                    .appendTo(operationInProgressDiv)
                                    .text("Azure Operation In Progress: " + status.azureOperationInProgress);

                                self._watchAzureOperationInProgress(operationInProgressDiv);
                            }

                            Solovis.Rpc.invoke(
                                "~/Rpc/DbServers/GetAllDatabaseInfo",
                                {
                                    includeSizeInMB: true,
                                    filterServer: self._envInfo.databaseServer,
                                    filterDatabaseName: self._envInfo.databaseName
                                },
                                function (response, success) {
                                    if (success) {
                                        let dbList = response.result.databases;
                                        if (!_.isEmpty(dbList) && dbList[0].name === self._envInfo.databaseName) {
                                            let dbInfo = dbList[0];
                                            addNameValueText("Size (MB)", dbInfo.sizeInMB);
                                            addNameValueText("SQL Azure", status.isSqlAzure ? "Yes" : "No");

                                            if (status.isSqlAzure) {
                                                addNameValueText("Azure Edition", dbInfo.azureEdition);
                                                addNameValueText("Azure Elastic Pool", dbInfo.azureElasticPoolName);
                                                addNameValueText("Azure Service Objective", dbInfo.azureServiceObjective);

                                                let changeTierButton = $("<button>").text("Change Azure Service Tier").appendTo(extraActionsDiv)
                                                    .click(function () {
                                                        let changeServiceTierDialog = new SolovisGateway.Admin.DbServers.ChangeDatabaseServiceTierDialog({
                                                            server: self._envInfo.databaseServer,
                                                            databaseName: self._envInfo.databaseName,
                                                            initialElasticPool: dbInfo.azureElasticPoolName,
                                                            initialServiceTier: !dbInfo.azureElasticPoolName ? dbInfo.azureServiceObjective : null,
                                                            changeRequestedCallback: function () { self._updateDbStatusDisplay(); }
                                                        });
                                                        changeServiceTierDialog.show();
                                                    });
                                            }
                                        }
                                        else {
                                            addNameValueText("ERROR", "Unable to retrieve extra info. Is database server registered?");
                                        }
                                    }
                                    else {
                                        addNameValueText("ERROR", "Unable to retrieve extra info. Call to server failed.");
                                    }
                                });
                        }
                        else {
                            statusDiv.text("ERROR: Checking status failed (unable to determine database status at this time).");
                        }
                    }
                });
        }


        private _watchAzureOperationInProgress(operationInProgressDiv) {
            let self = this;
            setTimeout(function () {
                Solovis.Rpc.invoke(
                    "~/Admin/DataEnvironmentAdmin/CheckDatabaseStatus",
                    {
                        dataEnvironmentId: self._dataEnvironmentId
                    },
                    function (response, success) {
                        if (success) {
                            let status = response.result.status;
                            
                            if (status.azureOperationInProgress) {
                                operationInProgressDiv.html(
                                    $("<div style='font-weight: bold; padding: 7px; border: 1px solid #ea7272; background-color: #fec5c5'>")                                        
                                        .append($("<span>").text("Azure Operation In Progress: " + status.azureOperationInProgress))
                                        .append($("<span>").text(" -- Last Checked: " + new Date().toLocaleTimeString()))
                                );                                

                                self._watchAzureOperationInProgress(operationInProgressDiv);
                            }
                            else {
                                operationInProgressDiv.html(
                                    $("<div style='font-weight: bold; padding: 7px; border: 1px solid #72ea72; background-color: #c5fec5'>")
                                        .text("Azure Operation Complete")
                                );

                                setTimeout(
                                    function () {
                                        self._updateDbStatusDisplay();
                                    },
                                    3000);
                            }                            
                        }
                    });
            }, 5000);
        }


        private async _updateCustomDataDiv() {
            this._customDataDiv.html("");
            this._customDataDiv.toggle(true);
            $("<h3>").text("Custom Data").appendTo(this._customDataDiv);

            let customDataResponse = await Solovis.Rpc.invoke("~/Rpc/DataEnv/GetDataEnvironmentCustomData", { dataEnvironmentId: this._dataEnvironmentId });
            let customDataJson = customDataResponse.result.customDataJson;
            let customData: any = {};
            if (customDataJson) {
                customData = JSON.parse(customDataJson);
                if (!customData) {
                    customData = {};
                }
            }

            let allowModelEnvironmentCaching = !!customData.allowModelEnvironmentCaching;

            let table = $("<table>").addClass("table table-striped").appendTo(this._customDataDiv);
            let colgroup = $("<colgroup>").appendTo(table);
            let col = $("<col>").css("width", "150px").appendTo(colgroup);

            let tbody = $("<tbody>").appendTo(table);

            let addNameValueHtml = function (labelText, valueHtml) {
                let row = $("<tr>").appendTo(tbody);
                $("<td>").css("vertical-align", "middle")
                    .append($("<strong>").text(labelText))
                    .appendTo(row);
                $("<td>").css("vertical-align", "middle")
                    .html(Solovis.isNotNull(valueHtml) ? valueHtml : "")
                    .appendTo(row);
            };

            let addNameValueText = function (labelText, valueText) {
                addNameValueHtml(labelText, $("<span>").text(Solovis.isNotNull(valueText) ? valueText : ""));
            };

            let extraActionsDiv = $("<div>").appendTo(this._customDataDiv);

            if (allowModelEnvironmentCaching) {
                let cacheSpan = $("<span>");
                cacheSpan.append(document.createTextNode("Enabled "));
                let disableLink = $("<a>").text("(disable)").appendTo(cacheSpan);
                disableLink.click(() => this._showToggleAllowModelEnvironmentCaching(false));
                addNameValueHtml("Allow Model Environment Caching", cacheSpan);
            }
            else {
                let cacheSpan = $("<span>");
                cacheSpan.append(document.createTextNode("Disabled "));
                let enableLink = $("<a>").text("(enable)").appendTo(cacheSpan);
                enableLink.click(() => this._showToggleAllowModelEnvironmentCaching(true));
                addNameValueHtml("Allow Model Environment Caching", cacheSpan);
            }

            $("<a>").text("Edit Custom Data JSON")
                .appendTo(extraActionsDiv)
                .click(() => this._showCustomDataJsonEditor());

            let editCustomDataHelpLink = $("<a>").append($("<span class='fa fa fa-question-circle'>")).css("margin-left", "5px");
            editCustomDataHelpLink.click(() => {
                Solovis.Site.HelpManager.showCustomHelpDialog({
                    text: "'Data Environment Custom Data' JSON contract is defined by SolovisGateway.AdminApi.Contracts.Backplane.DataEnvironmentCustomData."
                });
            });
            extraActionsDiv.append(editCustomDataHelpLink);
        }

        private _showToggleAllowModelEnvironmentCaching(newEnabled: boolean) {
            let message = (newEnabled ? "Enable" : "Disable") + " model environment caching?";
            Solovis.UI.confirm(message, "Model Environment Caching", async (confirmed) => {
                if (confirmed) {
                    await Solovis.Rpc.invokeAndWait("~/Rpc/DataEnv/EnableCachedModelEnvironment", { dataEnvironmentId: this._dataEnvironmentId, enabled: newEnabled });
                    this._updateCustomDataDiv();
                }
            });
        }

        private async _showCustomDataJsonEditor() {
            let customDataResponse = await Solovis.Rpc.invokeAndWait("~/Rpc/DataEnv/GetDataEnvironmentCustomData", { dataEnvironmentId: this._dataEnvironmentId });
            let customDataJson = customDataResponse.result.customDataJson;
            let version = customDataResponse.result.version;

            let jsonDialog = new Solovis.UI.Dialogs.JsonDialog({
                json: customDataJson,
                canEdit: true,
                autoIndentSpaces: 2,
                applyCallback: async (newJson) => {
                    let saveResponse = await Solovis.Rpc.invokeAndWait(
                        "~/Rpc/DataEnv/UpdateCustomDataJsonIfExpectedVersionMatches",
                        {
                            dataEnvironmentId: this._dataEnvironmentId,
                            customDataJson: newJson,
                            expectedVersion: version
                        });

                    if (saveResponse.result === true) {
                        this._updateCustomDataDiv();
                        Solovis.UI.alert("Custom data updated.");                        
                    }
                    else {
                        Solovis.UI.alert("ERROR: Someone else changed underyling data before you saved. Please retry.");
                    }
                }
            });
            jsonDialog.show();                      
        }


        private _refresh() {
            let self = this;

            Solovis.Rpc.invokeAndWait(
                "~/Admin/DataEnvironmentAdmin/GetDataEnvironmentSummary",
                { dataEnvironmentId: this._dataEnvironmentId },
                function (response, success) {
                    if (success) {
                        self._envInfo = response.result.dataEnvironment;
                        self._updateEnvironmentTable();
                    }                   
                });
        }

        private _showEditEnvironment() {
            let self = this;
            
            SolovisGateway.Admin.DataEnvironments.EditDataEnvironmentEditorDialog.showDialog({
                dataEnvironmentId: this._dataEnvironmentId,
                saveCallback: function () {
                    self._refresh();
                }
            });
        }

        private _showCreateDatabase() {
            let self = this;

            let createDatabaseDialog = new SolovisGateway.Admin.DataEnvironments.CreateEnvironmentDatabaseDialog({
                dataEnvironmentId: this._dataEnvironmentId,
                saveCallback: function () {
                    self._refresh();
                }
            });
            createDatabaseDialog.show();
        }

        private _showEraseDataEnvironment() {
            let self = this;
            Solovis.UI.confirm("Erase data environment?", "Erase Data Environment",
                function (confirmed) {
                    if (confirmed) {
                        Solovis.Rpc.invokeAndWait(
                            "~/Admin/DataEnvironmentAdmin/EraseDataEnvironment",
                            { dataEnvironmentId: self._dataEnvironmentId },
                            function (response, success) {
                                if (success) {
                                    self.container.html("");
                                    self.container.text("Data environment has been deleted.");                                    
                                }
                            });
                    }
                });
        } 

        private _showModules() {
            let self = this;

            let alertAlreadyShown = false;
            let moduleListDiv = $("<div>");

            let updateModuleList = function () {
                Solovis.Rpc.invokeAndWait(
                    "~/Admin/DataEnvironmentAdmin/GetOptionalModuleSettings",
                    { dataEnvironmentId: self._dataEnvironmentId },
                    function (response, success) {
                        if (success) {
                            moduleListDiv.html("");

                            $(response.result.modules).each(function (i, module: any) {
                                var moduleDiv = $("<div>").appendTo(moduleListDiv);

                                $("<span>").text(module.name).appendTo(moduleDiv);
                                $("<span>").text(": " + (module.enabled ? "enabled" : "disabled")).appendTo(moduleDiv);

                                if (module.enabled) {
                                    $("<a>").text("(disable)").css("padding-left", "10px").appendTo(moduleDiv)
                                        .click(function () {
                                            self._setModuleStatus(module.name, false, function () {
                                                updateModuleList();
                                            });
                                        });
                                }
                                else {
                                    $("<a>").text("(enable)").css("padding-left", "10px").appendTo(moduleDiv)
                                        .click(function () {
                                            self._setModuleStatus(module.name, true, function () {
                                                updateModuleList();
                                            });
                                        });
                                }
                            });

                            if (!alertAlreadyShown) {
                                alertAlreadyShown = true;
                                Solovis.UI.alert(moduleListDiv, "Modules");
                            }
                        }
                    });
            };

            updateModuleList();
        } 

        private _setModuleStatus(moduleName, enabled, successCallback) {
            var self = this;
            Solovis.Rpc.invokeAndWait(
                "~/Admin/DataEnvironmentAdmin/SetOptionalModuleStatus",
                { dataEnvironmentId: self._dataEnvironmentId, moduleName: moduleName, enabled: enabled },
                function (response, success) {
                    if (success) {
                        successCallback();
                    }
                });
        }

        private _reloadEnvironmentPoolData() {
            let self = this;
            Solovis.Rpc.invokeAndWait(
                "~/Admin/DataEnvironmentAdmin/ReloadEnvironmentPoolData",
                { dataEnvironmentId: self._dataEnvironmentId },
                function (response, success) {
                    if (success) {
                        Solovis.UI.alert("Environment pool data reloaded.");
                    }
                });
        } 
    }
}